import { buttonVariants, StatusScreen } from '@servicetim/ui/components';
import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <StatusScreen
      tone="info"
      title="Page not found"
      description="The address does not match any admin page."
      action={
        <Link to="/" className={buttonVariants({ variant: 'outline' })}>
          Go to the dashboard
        </Link>
      }
    />
  );
}
